/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountCredentialsForRackspace extends models.ServiceAccountCredentialsForBasicAuth {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountCredentialsForRackspace");
    }

    getFixupPrototypeFunction() { return ServiceAccountCredentialsForRackspace.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountCredentialsForRackspace>): ServiceAccountCredentialsForRackspace {
        let obj = Object.assign(new ServiceAccountCredentialsForRackspace(), model);
        ServiceAccountCredentialsForRackspace.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountCredentialsForRackspace>): ServiceAccountCredentialsForRackspace {
        if (!model) return null;
        return ServiceAccountCredentialsForRackspace.newInstance(<ServiceAccountCredentialsForRackspace> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountCredentialsForRackspace) {
        if (!obj) return;

        models.ServiceAccountCredentialsForRackspace.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountCredentialsForRackspace): boolean {
        if (models.ServiceAccountCredentialsForBasicAuth.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountCredentialsForRackspace.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
